import adhese from './adhese';
import appnexus from './appnexus';
import def from './default';
import improvedigital from './improvedigital';
import msft from './msft';
import rubicon from './rubicon';

export default {
	'default': def,
	rubicon,
	improvedigital,
	'imprweborama': improvedigital,

	appnexus,
	'gps': appnexus,
	'plista': appnexus,
	'groupm': appnexus,
	'weborama': appnexus,

	'adhese': adhese,

	msft,
	'gps-msft': msft,
	'plista-msft': msft,
	'groupm-msft': msft,
	'weborama-msft': msft,
};
